import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
const tabBarHeight = Platform.OS === 'ios' ? 52 : 56;
const useBottomTabHeight = () => {
    const { bottom } = useSafeAreaInsets();
    return bottom ? 47 + bottom : tabBarHeight;
};
export default useBottomTabHeight;
